import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatearFecha',
  standalone: true 
})
export class FormatearFechaPipe implements PipeTransform {

  transform(fechaISO: any): string {
    if (!fechaISO) {
      return '';
    }

    const fecha = new Date(fechaISO);
    const dia = fecha.getDate().toString().padStart(2, '0'); 
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');  
    const anio = fecha.getFullYear(); 
    const fechaFormateada = `${dia}/${mes}/${anio}`;
    return fechaFormateada;
  }

}
